import { Component } from '@angular/core';

@Component({
  selector: 'app-greenscore-modal-fr',
  templateUrl: './greenscore-modal-fr.component.html',
  styleUrls: ['./greenscore-modal-fr.component.scss'],
  standalone: false,
})
export class GreenscoreModalFrComponent {
  constructor() {}
}
